import React, { Component } from 'react'
import Section from '../shared/Section'
import Header from './Header'
import Carousel from './Carousel'

export class Testimonials extends Component {
  render() {
    const baseClass = 'testimonials'
    return (
      <Section>
        <Header />
        <Carousel parentClass={baseClass} />
      </Section>
    )
  }
}

export default Testimonials
